import "Layouts/shopping";

import 'Ui/slider';
import 'Ui/toggle';

import './shopping-cart-jquery';

import "Components/shopping/cart-totals";
import "Components/shopping/vouchers";
import "Components/shopping/points";

import { formatPrice } from "FrontendJsAssets/common/format";

window.rEvent.on('Custom.Cart.updatedItem', function ({ input, response }) {
    if (response.refreshRequired) {
        window.location.reload()
    }

    const $shoppingAside = $('.shopping-aside');
    if (response.aside && $shoppingAside.length) {
        $shoppingAside.replaceWith(response.aside);
    }

    const $rewardPromotions = $('.js-reward-promotions');
    if (response.rewardPromotions && $rewardPromotions.length) {
        $rewardPromotions.replaceWith(response.rewardPromotions);
    }

    const $productRow = $(input).closest('.js-cart-product-row');
    if (
        // $productRow.hasClass('has-promotion') || // ? -> toto aktivovat ak bude treba
        document.querySelectorAll('.js-cart-product-row').length !== Object.values(response.products).length
    ) {
        window.location.reload()
    }

    document
        .querySelector(`.js-cart-product-row[data-cart-id="${response.item.id}"]`)
        .querySelectorAll('.js-accessory-quantity')
        .forEach((quantityEl) => {
            if (response.item.quantity > 1) {
                quantityEl.innerHTML = response.item.quantity + 'x ';
            } else {
                quantityEl.innerHTML = '';
            }
        });

    document
        .querySelector(`.js-cart-product-row[data-cart-id="${response.item.id}"]`)
        .querySelectorAll('.js-accessory-total-price')
        .forEach((priceEl) => {
            const singularPrice = priceEl.dataset.singularPrice;

            priceEl.dataset.productCartQuantity = response.item.quantity;

            if (response.item.quantity > 0 && singularPrice) {
                priceEl.innerHTML = formatPrice(response.item.quantity * singularPrice)
            } else {
                priceEl.innerHTML = ''
            }
        });
});

rEvent.on('Cart.product.after_add', function(response) {
    if (response.status) {
        window.location.reload();
    }
});